import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watch } from '@nuxtjs/composition-api'

interface Props {
    visible: boolean;
    width?: string;
    fullscreen?: boolean,
    topOffset?: string,
    lockScroll?: boolean,
    customClass?: string,
    appendToBody?: boolean;
    modalAppendToBody?: boolean;
    closeOnClickModal?: boolean;
    closeOnPressEscape?: boolean;
    destroyOnClose?: boolean;
    center?: boolean;
    modal?: boolean;
    beforeClose?: Function;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Basic',
  props: {
    visible: { type: Boolean, default: false },
    width: null,
    fullscreen: { type: Boolean, default: false },
    topOffset: null,
    lockScroll: { type: Boolean, default: false },
    customClass: null,
    appendToBody: { type: Boolean, default: true },
    modalAppendToBody: { type: Boolean, default: true },
    closeOnClickModal: { type: Boolean, default: true },
    closeOnPressEscape: { type: Boolean, default: true },
    destroyOnClose: { type: Boolean, default: true },
    center: { type: Boolean, default: false },
    modal: { type: Boolean, default: true },
    beforeClose: null
  },
  emits: ['update:visible', 'close', 'open', 'closed', 'opened'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { visible: boolean, width?: string, fullscreen: boolean, topOffset?: string, lockScroll: boolean, customClass?: string, appendToBody: boolean, modalAppendToBody: boolean, closeOnClickModal: boolean, closeOnPressEscape: boolean, destroyOnClose: boolean, center: boolean, modal: boolean, beforeClose?: Function };





const {
    visible,
    width,
    fullscreen,
    topOffset,
    lockScroll,
    customClass,
    appendToBody,
    modalAppendToBody,
    closeOnClickModal,
    closeOnPressEscape,
    destroyOnClose,
    center,
    modal,
    beforeClose,
} = toRefs(props);

const customClassComputed = computed(() => {
    const classes = ['affility-popup-base'];
    if (customClass.value) {
        classes.push(customClass.value);
    }
    if (modal.value) {
        classes.push('affility-popup-base-as-modal');
    }
    return classes.join(' ');
});

const internalVisible = ref(visible.value);

watch(visible, (value, oldVal) => {
    if (!!value === !!oldVal) return;
    internalVisible.value = value;
    $emit('update:visible', value);
});

watch(internalVisible, (value) => {
    if (value === visible.value) return;
    $emit('update:visible', value);
});


return { __sfc: true,$emit, props, visible, width, fullscreen, topOffset, lockScroll, customClass, appendToBody, modalAppendToBody, closeOnClickModal, closeOnPressEscape, destroyOnClose, center, modal, beforeClose, customClassComputed, internalVisible }
}

})